import notEmpty from '../../core/util/notEmpty';
import assert from '../../core/util/assert';
import type { FutureStockQuantities, StockQuantity } from '../types';
import getStockStatus from './getStockStatus';

/* eslint complexity: ['error', 12] */
// eslint-disable-next-line max-statements
const getMaxOrderableQuantityFromStock = ({
    store,
    stock,
    futureStock,
    currentStockOnly = false,
}: {
    store: string;
    stock?: StockQuantity;
    futureStock?: FutureStockQuantities;
    currentStockOnly?: boolean;
}) => {
    if (!stock && !futureStock) {
        return Infinity;
    }

    const stockStatuses = getStockStatus({
        store,
        stock,
        futureStock,
        currentStockOnly,
    });

    if (
        [
            'noLongerAvailable',
            'cannotBeOrderedInDesiredBranch',
            'notAvailableForPreorder',
        ].includes(stockStatuses[0].status)
    ) {
        return 0;
    }

    assert(stock, 'stock is required.');
    assert(notEmpty(stock.quantity), 'stock.quantity cannot be empty.');

    const futureQuantities = futureStock?.quantities ?? [];

    if (!currentStockOnly) {
        if (
            stock.nextAvailability === 'onDemand' ||
            stock.nextAvailability === 'unknown'
        ) {
            return Infinity;
        }

        if (futureQuantities.some(item => !!item.date && !item.quantity)) {
            return Infinity;
        }
    }

    const availableQuantity = stock.quantity;
    const availableInFutureQuantity = currentStockOnly
        ? 0
        : futureQuantities.reduce(
              (total, { quantity }) => total + quantity!,
              0
          );

    return availableQuantity + availableInFutureQuantity;
};

export default getMaxOrderableQuantityFromStock;
